import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const Purchase: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 24 24"
    sx={{
      width: '24px',
      height: '24px',
      fill: 'none',
      ...sx,
    }}
    {...props}
  >
    <path
      d="M10 16V14.0003M10 14.0003V12M10 14.0003L12 14.0005M10 14.0003L8 14M21 12V11.2C21 10.0799 21 9.51984 20.782 9.09202C20.5903 8.71569 20.2843 8.40973 19.908 8.21799C19.4802 8 18.9201 8 17.8 8H3M21 12V16M21 12H19C17.8954 12 17 12.8954 17 14C17 15.1046 17.8954 16 19 16H21M21 16V16.8C21 17.9201 21 18.4802 20.782 18.908C20.5903 19.2843 20.2843 19.5903 19.908 19.782C19.4802 20 18.9201 20 17.8 20H6.2C5.0799 20 4.51984 20 4.09202 19.782C3.71569 19.5903 3.40973 19.2843 3.21799 18.908C3 18.4802 3 17.9201 3 16.8V8M18 8V7.2C18 6.0799 18 5.51984 17.782 5.09202C17.5903 4.71569 17.2843 4.40973 16.908 4.21799C16.4802 4 15.9201 4 14.8 4H6.2C5.07989 4 4.51984 4 4.09202 4.21799C3.71569 4.40973 3.40973 4.71569 3.21799 5.09202C3 5.51984 3 6.0799 3 7.2V8"
      stroke="#B4EB56"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8 19.5H4" stroke="#B4EB56" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  <path
    d="M16.25 12.75C18.597 12.75 20.5 14.653 20.5 17C20.5 19.347 18.597 21.25 16.25 21.25C13.903 21.25 12 19.347 12 17C12 14.653 13.903 12.75 16.25 12.75"
    stroke="#B4EB56"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M17.903 16.174L15.837 18.24L14.597 17"
    stroke="#B4EB56"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path d="M8 14.5H4" stroke="#B4EB56" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  <path d="M20 9.5H4" stroke="#B4EB56" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  <path d="M20 4.5H4" stroke="#B4EB56" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>;
